var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretDouble = function SvgCaretDouble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#36ABFF",
    fillRule: "evenodd",
    d: "M12.744 8.923a.833.833 0 0 0 1.179-1.179l-3.334-3.333a.833.833 0 0 0-1.178 0L6.078 7.744a.833.833 0 0 0 1.178 1.179L10 6.178l2.744 2.745Zm0 2.154a.833.833 0 1 1 1.179 1.179l-3.334 3.333a.833.833 0 0 1-1.178 0l-3.333-3.333a.833.833 0 1 1 1.178-1.179L10 13.821l2.744-2.744Z",
    clipRule: "evenodd"
  })));
};
export default SvgCaretDouble;